import { TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { Controller, useFormContext } from "react-hook-form";
import { FormType } from "src/types/filters/filters";
import { IMainFiltersDataDto } from "src/types/filters/main-filters-drawer-type";
import { useQueryParam } from "use-query-params";

type endDateFilterPropsType = {
  dashboardFilter: IMainFiltersDataDto;
};

const EndDateFilter = ({ dashboardFilter }: endDateFilterPropsType) => {
  const { control, watch } = useFormContext<FormType>();

  return (
    <Controller
      name="end_date"
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <DatePicker
            {...field}
            label="End date"
            inputFormat="yyyy-MM-dd"
            renderInput={(params) => (
              <TextField {...params} error={!!error} helperText={error?.message} />
            )}
            minDate={dashboardFilter?.start_date}
            maxDate={dashboardFilter?.end_date}
          />
        );
      }}
    />
  );
};

export default EndDateFilter;
